// extracted by mini-css-extract-plugin
export var border = "_29-8";
export var brand = "_29-t";
export var button = "_29-l";
export var center = "_29-a";
export var centered = "_29-6";
export var closeButton = "_29-c";
export var disabledWrapper = "_29-m";
export var error = "_29-p";
export var extraLarge = "_29-4";
export var extraSmall = "_29-1";
export var fill = "_29-i";
export var footer = "_29-h";
export var footerAction = "_29-j";
export var footerButtons = "_29-k";
export var header = "_29-7";
export var headerWithClose = "_29-d";
export var icon = "_29-o";
export var info = "_29-s";
export var inline = "_29-9";
export var large = "_29-3";
export var main = "_29-e";
export var modal = "_29-0";
export var nearFull = "_29-5";
export var neutral = "_29-u";
export var noPadding = "_29-g";
export var none = "_29-v";
export var scrollable = "_29-f";
export var small = "_29-2";
export var success = "_29-r";
export var tight = "_29-n";
export var titleIcon = "_29-b";
export var warn = "_29-q";